import { useTranslation } from "react-i18next";
import { Card } from "semantic-ui-react";

import ApprovalAction from "./ApprovalAction";
import DeletionAction from "./DeletionAction";
import ActionsContext from "./context/ActionsContext";

export default function Actions({ data, children }) {
	const { t } = useTranslation();

	return (
		<ActionsContext.Provider value={{ data }}>
			<Card fluid>
				<Card.Content>
					<Card.Header>{t("actions", "Actions")}</Card.Header>
				</Card.Content>
				{children}
			</Card>
		</ActionsContext.Provider>
	);
}

Actions.ApprovalAction = ApprovalAction;
Actions.DeletionAction = DeletionAction;
